import React, { useState, useEffect } from "react";
import Spinner from "../common/Spinner";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { XMarkIcon } from "@heroicons/react/20/solid";


const TimesheetCommentModal = ({
    timesheet,
    showComments,
    modalSaving
}) => {

    const [comment, setComment] = useState();
    if (!timesheet) return null


    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="block block-themed block-transparent remove-margin-b">
                <div className="block-header bg-primary-dark">
                  <ul className="block-options">
                    <li>
                      <button type="button" onClick={() => { showComments(null) }}>
                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                      </button>
                    </li>
                  </ul>
                  <h3 className="block-title">Comments for {format(new Date(timesheet.date), "do MMM yyyy")}</h3>
                </div>
                <div className="block-content">
    
                    { /* UNDER CONSTRUCTION */ }
                  {timesheet?.comments?.map(comment => (
                      <div>
                        <span style={{
                          fontWeight: "bold"
                        }}>{comment?.byName || ''}</span>
                        <span style={{
                          fontSize: "12px"
                        }}> - {format(new Date(comment.createdAt || timesheet.date), "do MMM yyyy HH:mm")}</span>
                        <p>{comment?.comment || comment}</p>
    
                      </div>
                    ))
                  }
                  {/* {userPermissions != 'Read' && */}
                    <div className="form-group">
                      <div className="col-sm-12">
                        <label>Add Comment</label>
                        <textarea
                          className="form-control form-input"
                          name="comment"
                          onChange={(e) => {
                            setComment(e.target.value)
                          }}
                        >{comment}</textarea>
                        <div className="clearfix" />
                      </div>
                      <div className="clearfix" />
                    </div>
                  {/* } */}
    
                  {comment &&
                    <button className="btn btn-success pull-right" onClick={() => console.log("test")} style={{ marginRight: 0, marginBottom: "20px" }}>Save Comment</button>
                  }
    
                  {!comment &&
                    <button className="btn btn-default pull-right" style={{ marginRight: 0, marginBottom: "20px" }} onClick={() => { showComments(null) }}>Close</button>
                  }
    
                  
                     {
                        modalSaving &&
                        <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                        <Spinner
                            style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                            className="animate-spin -ml-1 mr-3 h-5 w-5 "
                        />
                        <div style={{ float: 'left' }}>Saving</div>
                        </button>
                    }
                  <div className="clearfix" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
}

const mapStateToProps = (state) => { 

    const timesheet = state.timesheets.showComments
    return {
        timesheet
    }
}


const mapDispatchToProps = dispatch => ({
    showComments: (timesheet) => dispatch(ACTIONS.showComments(timesheet)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TimesheetCommentModal) 
  